'use client';

import { Layout } from 'components/power-plugs-redeem/Layout';
import { RedeemForm } from 'components/power-plugs-redeem/RedeemForm';

export default function PowerPlugsRedeemClient() {
  return (
    <Layout>
      <RedeemForm />
    </Layout>
  );
}
